import { RecordByPrimaryKey } from "@pdfking/templates"

import type { PrintMode } from "#internal"

export const PrintModeList = RecordByPrimaryKey<PrintMode>([
  {
    id: "no",
    name: "No",
    is_front: false,
    is_rear: false,
    use_symmetry: undefined,
  },
  {
    id: "f",
    name: "FRONT",
    is_front: true,
    is_rear: false,
    use_symmetry: undefined,
  },
  {
    id: "r",
    name: "REAR",
    is_front: false,
    is_rear: true,
    use_symmetry: undefined,
  },
  {
    id: "fr",
    name: "FRONT_REAR",
    is_front: true,
    is_rear: true,
    use_symmetry: undefined,
  },
  {
    id: "bv",
    name: "FRONT_BACK",
    is_front: true,
    is_rear: true,
    use_symmetry: "x",
  },
  {
    id: "pt",
    name: "GRIPPER_HEAD",
    is_front: true,
    is_rear: true,
    use_symmetry: "y",
  },
  {
    id: "s",
    name: "SYMMETRIC",
    is_front: true,
    is_rear: true,
    use_symmetry: "both",
  },
] as const)
